exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".opacity-transition {\n  opacity: 0;\n  height: 0;\n  visibility: hidden;\n  transition: opacity 0.2s ease, linear 0.2s;\n}\n\n.opacity-transition.show {\n  opacity: 1;\n  height: auto;\n  visibility: visible;\n}", ""]);

